import React, { useEffect } from 'react';
import Settings from './shared/config/Settings';

const CSPMeta = () => {
  useEffect(() => {
    // const apiEndpoint = process.env.REACT_APP_SERVICE_BASE_URL;
    const apiEndpoint= Settings.apiUrl
    const cspContent = `
      default-src 'self';
      style-src 'self' 'unsafe-inline';
      script-src 'self' 'strict-dynamic' 'unsafe-inline' https:;
      script-src-elem 'self'  https://www.gstatic.com  https://www.googletagmanager.com https://www.google.com/  ;
      manifest-src 'self';
      font-src 'self' ;
      connect-src 'self' data: blob: ${apiEndpoint}  https://firebaseinstallations.googleapis.com https://firebase.googleapis.com https://www.google-analytics.com;
      img-src 'self' data: https://www.google-analytics.com/ https://via.placeholder.com/ https://devnhlapp.indici.ie https://www.googletagmanager.com;
      frame-src 'self'   data: blob: filesystem: about: ws: wss: https://www.google.com/  ;
      frame-ancestors 'self' ${apiEndpoint}  ;
      style-src-elem * 'self' 'unsafe-inline' fonts.googleapis.com https://www.google-analytics.com *;
      media-src 'self' ;
      object-src 'self' data: blob: ;
      base-uri 'self';
    `.replace(/\n\s+/g, ' ').trim();

    const meta = document.createElement('object');
    meta.httpEquiv = 'Content-Security-Policy';
    meta.content = cspContent;

    document.head.appendChild(meta);

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return null;
};

export default CSPMeta;